/**
 * Клас для роботи з DOM
 *
 * @package AGDS
 * @category Modules
 * @module Utils
 * @see AGDSApp
 * @author Andy Groove
 * @since 1.0.0
 */
export default class Utils {
    /**
     * Конструктор
     *
     * @param {Object} options
     */
    constructor(options = {}) {}

    /**
     * Ініціалізація
     *
     * @returns {void}
     */
    init() {
        // номери секцій
        this.sectionTitleNum();

        // Запуск відео
        this.videoPlay();
    }

    /**
     * Приховати елемент.
     *
     * @param {Object} els - Об'єкт елементів
     * @returns {void}
     */
    hideElement(els) {
        if (!els) return;
        const elements = Array.isArray(els) ? els : [els];

        elements.forEach((el) => {
            if (!el) return;

            el.style.display = "none";
            el.style.visibility = "hidden";
            el.style.opacity = "0";
            el.style.pointerEvents = "none";
        });
    }

    /**
     * Показати елемент.
     *
     * @param {Object} els - Об'єкт елементів
     * @returns {void}
     */
    showElement(els) {
        if (!els) return;
        const elements = Array.isArray(els) ? els : [els];

        elements.forEach((el) => {
            if (!el) return;

            el.style.display = "block";
            el.style.visibility = "visible";
            el.style.opacity = "1";
            el.style.pointerEvents = "auto";
        });
    }

    /**
     * Встановити номери секцій
     *
     * @returns {void}
     */
    sectionTitleNum() {
        const secTitles = document.querySelectorAll(".section-title");
        if (secTitles.length < 0) return;

        secTitles.forEach((item, index) => {
            const numElement = item.querySelector(".num");
            if (numElement) {
                numElement.textContent = (index + 1).toString().padStart(3, "0");
            }
        });
    }

    /**
     * Запуск відео при кліку
     *
     * @returns {void}
     */
    videoPlay() {
        const wrappers = document.querySelectorAll(".video-wrap");
        if (!wrappers.length) return;

        wrappers.forEach((wrapper) => {
            const video = wrapper.querySelector("video");
            if (!video) return;

            this.initVideoToggle({
                wrapper,
                button: wrapper.querySelector(".btn-play"),
                targets: [wrapper],
                activeClass: "_playing",
                ignoreSelector: ".btn-mute",
                isActive: () => !video.paused,
                activate: () => video.play(),
                deactivate: () => video.pause(),
            });

            this.initVideoToggle({
                wrapper,
                button: wrapper.querySelector(".btn-mute"),
                targets: [wrapper.querySelector(".btn-mute"), video],
                activeClass: "_muted",
                isActive: () => video.muted,
                activate: () => {
                    video.muted = true;
                },
                deactivate: () => {
                    video.muted = false;
                },
                stopPropagation: true,
            });

            video.addEventListener("ended", () => {
                wrapper.classList.remove("_playing");
            });
        });
    }

    /**
     * Перемикач контролів відео.
     *
     * @param {Object} params
     * @returns {void}
     */
    initVideoToggle({ wrapper, button, targets, activeClass, ignoreSelector, isActive, activate, deactivate, stopPropagation = false }) {
        if (!button) return;

        const syncState = () => {
            wrapper.classList.toggle(activeClass, isActive());
        };

        const toggle = (event) => {
            if (ignoreSelector && event.target.closest(ignoreSelector)) return;

            if (stopPropagation || event.currentTarget === button) {
                event.stopPropagation();
            }

            if (isActive()) {
                deactivate();
            } else {
                activate();
            }

            syncState();
        };

        targets.filter(Boolean).forEach((target) => {
            target.addEventListener("click", toggle);
        });

        syncState();
    }
}
